import React, {
    Component, useState
} from 'react'
import Select from 'react-select'
import Loader from './Loader'
import {
    PieChart,
    Pie,
    Tooltip,
    Legend,
    Cell
} from 'recharts'
import _ from 'underscore';
import * as Animated from 'react-select/lib/animated';



class CorpusSelector extends Component {
    constructor(props) {
        super(props);
        this.state = {
            corporaLoaded: false
        };
        this.hostname = process.env.API_HOSTNAME || "//ordtidni.arnastofnun.is"
//	this.hostname = process.env.REACT_APP_API_HOSTNAME || "http://127.0.0.1:3001"
//		this.hostname = process.env.REACT_APP_API_HOSTNAME || ""
    }

    componentDidMount() {
        fetch(this.hostname + "/lists/corpora")
            .then(res => res.json())
            .then(data => {
                // this.corpusData = data
                this.setState({
                    corporaLoaded: true,
                    corpusData: data
                })
            })
    }

    render() {
        if (!this.state.corporaLoaded) {
            return <Loader />
        }
        const corpusSelectOptions = this.state.corpusData.map((item, idx) => {
            return {
                value: item.titill,
                label: item.heiti || item.titill
            }
        });

		let categorizedCorpusData = {};

		let fl = 1;
		let clone = JSON.parse(JSON.stringify(this.state.corpusData));
		while (clone.length > 0) {
			categorizedCorpusData['Flokkur '+fl] = clone.splice(0, 10);

			fl++;
		}

        return (
            <div className="row">
				<div className="col col-6">
	                <CorporaPie
	                    corpusData={this.state.corpusData}
	                    selectedCorpora={this.props.selectedCorpora.map(corpora => corpora.value)}
						onPieClick={(e) => this.props.onPieSelect ? this.props.onPieSelect(e) : null}
	                    />
				</div>
				<div className="col col-6">
	                <label>
	                    Velja textasafn/söfn til að takmarka leit við:
					</label>
					{
						/*
                    <Select
                        components={Animated}
                        closeMenuOnSelect={false}
                        options={corpusSelectOptions}
                        isMulti
						value={this.props.selectedCorpora}
                        onChange={this.props.changeCorporaSelection}
                        placeholder='Veldu eitt eða fleiri textasöfn úr fellivalmyndinni...'
                        />
						*/
					}
					<CorpusCategorizedCheckList corpusData={categorizedCorpusData}
						onChange={this.props.changeCorporaSelection}
						selectedCorpora={this.props.selectedCorpora} />
				</div>
			</div>
        )
    }
}

const CorpusCategorizedCheckList = (props) => {
	return <div className="mt-2" style={{
			border: '1px solid hsl(0,0%,80%)',
			padding: 10,
			borderRadius: 4,
			overflowX: 'auto',
			maxHeight: 300
		}}>
			{
				(() => {
					let ret = [];

					let index = 0;

					for (let key in props.corpusData) {
						ret.push(<CategoryCheckboxList index={index}
							key={index}
							categoryName={key}
							listData={props.corpusData[key]}
							selectedCorpora={props.selectedCorpora}
							onSelectionChange={(event) => {
								props.onChange(event)
							}}
						/>)


						index++;
					}

					return ret;
				})()
			}
		</div>;
}

const CategoryCheckboxList = (props) => {
	//console.log(props.selectedCorpora)
	//console.log(props.listData)
	return <div key={props.index}>
		<div className="form-check">
			<input className="form-check-input"
				type="checkbox"
				id={'corpus-check-'+props.index}
				checked={_.some(props.selectedCorpora, (i) => _.some(props.listData, (ii) => ii.titill == i.value))}
				onChange={(event) => {
					let _selectedCorpora = JSON.parse(JSON.stringify(props.selectedCorpora));;
					if (event.target.checked) {
						_selectedCorpora = _selectedCorpora.concat(props.listData.map(i => {
							return {
								value: i.titill,
								label: i.heiti
							}
						}));
					}
					else {
						props.listData.forEach((item, i) => {
							_selectedCorpora.splice(_selectedCorpora.findIndex(i => i.value == item.titill), 1);
						});


					}

					props.onSelectionChange(_.uniq(_selectedCorpora, i => i.value));
				}}
			/>
			<label className="form-check-label" htmlFor={'corpus-check-'+props.index}>{props.categoryName}</label>
		</div>
		<div className="inner-list ml-2">
			{
				props.listData.map((item, subIndex) => <div key={props.index+'-'+subIndex} className="form-check">
					<input className="form-check-input"
						type="checkbox"
						value={item.titill}
						checked={_.findWhere(props.selectedCorpora, {value: item.titill})}
						id={'corpus-check-'+props.index+'-'+subIndex}
						onChange={(event) => {
							let _selectedCorpora = JSON.parse(JSON.stringify(props.selectedCorpora));

							if (event.target.checked) {
								if (!_.findWhere(_selectedCorpora, {value: item.titill})) {
									_selectedCorpora.push({
										value: item.titill,
										label: item.heiti
									});
								}
							}
							else {
								_selectedCorpora.splice(_selectedCorpora.findIndex(i => i.value == item.titill), 1);
							}

							props.onSelectionChange(_selectedCorpora)
						}}
					/>
					<label className="form-check-label" htmlFor={'corpus-check-'+props.index+'-'+subIndex}>{item.heiti}</label>
				</div>)
			}
		</div>
	</div>;
}

const CorporaPie = (props) => {
    const pieData = props.selectedCorpora.length ?
        props.corpusData.filter(item => props.selectedCorpora.includes(item.titill)).map(item => {item.heiti = item.heiti || item.titill; return item}) :
        props.corpusData.map(item => {item.heiti = item.heiti || item.titill; return item});
const COLORS = [
    '#ED8B61',
    '#D98F4E',
    '#C19342',
    '#A7963E',
    '#8C9742',
    '#72974D',
    '#58955B',
    '#40916A',
    '#2D8C78',
    '#288684',
    '#347E8B',
    '#48758D',
    '#5B6B8A',
    '#6D6182',
    '#795775',
    '#814D66',
    '#834655',
    '#804244',
    '#794035'
];
    const formatNumber = (num) => {
        return num.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ".")
    }
    const total = pieData ? pieData.reduce(((accumulator, item) => accumulator + item.fjoldi_lesmalsorda), 0) : 0
    return (
        <div>
            Orðafjöldi valinna málheilda: {formatNumber(total)}
            <PieChart width={400} height={400}>
                <Pie
                    cx='40%'
                    isAnimationActive={false}
                    data={pieData}
                    dataKey='fjoldi_lesmalsorda'
                    nameKey='heiti'
                    innerRadius='30%'
					onClick={(e) => props.onPieClick ? props.onPieClick(e) : null}
                    >
                    {
                        pieData.map((entry, index) => <Cell key={index} fill={COLORS[index % COLORS.length]}/>)
                    }
                </Pie>
                {/*<Legend wrapperStyle={{left: '25%', width: '80%'}} layout='horizontal' verticalAlign='middle' align='left' chartWidth={800} />*/}
                <Tooltip
                    formatter={(value, name, props) => {
                        const percent = (value/total*100).toFixed(1) + '%, ' + formatNumber(value) + ' orð'
                        return percent
                    }}
                    />
            </PieChart>
        </div>
    )
}


export default CorpusSelector



// WEBPACK FOOTER //
// ./src/Search/Corpora.js